import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('web-components-btn', wrap(Vue, () => import('~root/./src/components/Btn/Btn.vue?shadow')))

window.customElements.define('web-components-committee-card', wrap(Vue, () => import('~root/./src/components/CommitteeCard/CommitteeCard.vue?shadow')))

window.customElements.define('web-components-event-card', wrap(Vue, () => import('~root/./src/components/EventCard/EventCard.vue?shadow')))

window.customElements.define('web-components-event-card-large', wrap(Vue, () => import('~root/./src/components/EventCard/EventCardLarge.vue?shadow')))

window.customElements.define('web-components-events-list', wrap(Vue, () => import('~root/./src/components/EventsList/EventsList.vue?shadow')))

window.customElements.define('web-components-fit-text', wrap(Vue, () => import('~root/./src/components/FitText/FitText.vue?shadow')))

window.customElements.define('web-components-highlight-events-slide', wrap(Vue, () => import('~root/./src/components/HighlightEventsSlide/HighlightEventsSlide.vue?shadow')))

window.customElements.define('web-components-icon-calendar', wrap(Vue, () => import('~root/./src/components/Icons/IconCalendar.vue?shadow')))

window.customElements.define('web-components-icon-chat', wrap(Vue, () => import('~root/./src/components/Icons/IconChat.vue?shadow')))

window.customElements.define('web-components-icon-close', wrap(Vue, () => import('~root/./src/components/Icons/IconClose.vue?shadow')))

window.customElements.define('web-components-icon-envelop', wrap(Vue, () => import('~root/./src/components/Icons/IconEnvelop.vue?shadow')))

window.customElements.define('web-components-icon-intro', wrap(Vue, () => import('~root/./src/components/Icons/IconIntro.vue?shadow')))

window.customElements.define('web-components-icon-medal', wrap(Vue, () => import('~root/./src/components/Icons/IconMedal.vue?shadow')))

window.customElements.define('web-components-icon-phone', wrap(Vue, () => import('~root/./src/components/Icons/IconPhone.vue?shadow')))

window.customElements.define('web-components-icon-private-meeting', wrap(Vue, () => import('~root/./src/components/Icons/IconPrivateMeeting.vue?shadow')))

window.customElements.define('web-components-image-lock-ratio', wrap(Vue, () => import('~root/./src/components/ImageLockRatio/ImageLockRatio.vue?shadow')))

window.customElements.define('web-components-meeting-card', wrap(Vue, () => import('~root/./src/components/MeetingCard/MeetingCard.vue?shadow')))

window.customElements.define('web-components-pending-meeting-card', wrap(Vue, () => import('~root/./src/components/MeetingCard/PendingMeetingCard.vue?shadow')))

window.customElements.define('web-components-member-bio-card', wrap(Vue, () => import('~root/./src/components/MemberBioCard/MemberBioCard.vue?shadow')))

window.customElements.define('web-components-member-card', wrap(Vue, () => import('~root/./src/components/MemberCard/MemberCard.vue?shadow')))

window.customElements.define('web-components-member-info-card', wrap(Vue, () => import('~root/./src/components/MemberInfoCard/MemberInfoCard.vue?shadow')))

window.customElements.define('web-components-modal', wrap(Vue, () => import('~root/./src/components/Modal/Modal.vue?shadow')))

window.customElements.define('web-components-nationality-avatar', wrap(Vue, () => import('~root/./src/components/NationalityAvatar/NationalityAvatar.vue?shadow')))

window.customElements.define('web-components-progress-bar', wrap(Vue, () => import('~root/./src/components/ProgressBar/ProgressBar.vue?shadow')))

window.customElements.define('web-components-spinner-loading', wrap(Vue, () => import('~root/./src/components/SpinnerLoading/SpinnerLoading.vue?shadow')))

window.customElements.define('web-components-star-button', wrap(Vue, () => import('~root/./src/components/StarButton/StarButton.vue?shadow')))